import api from './api';
import {mapWorkingTimeDto} from '../dto/WorkingTimeDTO';

export const getAllWorkingTime = async () => {
    try {
        const res = await api.get('/WorkingTimeRules');
        console.log(res);
        console.log(res.data.map(mapWorkingTimeDto));
        return res.data.map(mapWorkingTimeDto);
    } catch (err) {
        console.error("Error adding working time:", err);
        throw err;
    }
}

export const addWorkingTime = async ({userId, ValidFrom, ValidUntil, Weekday, ExpectedHours}) => {
    try {
        const res = await api.post('/WorkingTimeRules', {
            userId, ValidFrom,
            ValidUntil, Weekday, ExpectedHours
        });
        return res.data;
    } catch (err) {
        console.error("Error adding working time:", err);
        throw err;
    }
};

export const deleteWorkingTime = async (id) => {
    try {
        const res = await api.delete(`/WorkingTimeRules/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting working time:", err);
        throw err;
    }
}

export const changeWorkingTime = async (userId, ValidFrom, ValidUntil, Weekday, ExpectedHours) => {
    try {
        const res = await api.patch('/WorkingTimeRules', {
            userId, ValidFrom,
            ValidUntil, Weekday, ExpectedHours
        });
        return res.data;
    } catch (err) {
        console.error("Error changing working time:", err);
        throw err;
    }
};